// src/app/menu-config.ts
import { HomeItem } from '../../models/home-item/home-item.model';

export const HOME_ITEMS: HomeItem[] = [
  {
    nombre: 'Listado de Facturas',
    icono: 'bi-file-ruled',
    url: 'facturas',
    contadores: true,
    nameContador: 'FACTURA',
    color:1,
    validacion: {
        roles: [
            'Administrador',
            'Administrador del proyecto',
            'Supervisor del proyecto',
            'Coordinador administrativo'
      ]
        }
    },
    {
        nombre: 'Listado de Refacturación',
        icono: 'bi-receipt-cutoff',
        url: 'refacturacion',
        contadores: true,
        nameContador: 'REFACTURA',
        color: 2,
        validacion: {
            roles: [
                'Administrador',
                'Administrador del proyecto',
                'Supervisor del proyecto',
                'Coordinador administrativo'
            ]
        }
    },
    {
        nombre: 'Listado de Deductivas',
        icono: 'bi-journal-x',
        url: 'deductiva',
        contadores: true,
        nameContador: 'Deductiva',
        color: 3,
        validacion: {
            roles: [
                'Administrador',
                'Administrador del proyecto',
                'Supervisor del proyecto',
                'Coordinador administrativo'
            ]
        }
    },
    {
        nombre: 'Listado de Penalizaciones',
        icono: 'bi-x-octagon',
        url: 'penalizacion',
        contadores: true,
        nameContador: 'Penalizacion',
        color: 4,
        validacion: {
            roles: [
                'Administrador', 
                'Administrador del proyecto', 
                'Supervisor del proyecto', 
                'Coordinador administrativo'
            ]
        }
    },
    {
        nombre: 'Reportes',
        icono: 'bi-clipboard2-data',
        url: 'reportes',
        color: 5,
        contadores: false,
        validacion: {
            roles: [
                'Administrador',
                'Director general adjunto',
                'Director general',
                'Director de estrategia de proyectos',
                'Supervisor del proyecto'
            ]
        }
    }
];
